/* eslint-disable import/prefer-default-export */
import { client } from 'lib/evi-api-gateway';

const url = `${process.env.REACT_APP_API_URL}/admin/interview_sign`;

// 验证token
export async function decodeQrcode(params) {
  return client.post({
    url: `${url}/decode_qrcode`,
    form: {
      ...params,
    },
  });
}

export async function decodeQrcodePublic(params) {
  return client.post({
    url: `${url}/decode_qrcode_public`,
    form: {
      ...params,
    },
  });
}
